import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import './Therapy.scss';

import IconList from '../../components/IconList/IconList';
import SectionTitle from '../../components/SectionTitle/SectionTitle';

import iconOne from '../../assets/symptoms/wurzelbehandlung.webp';
import iconTwo from '../../assets/symptoms/revision.webp';
import iconThree from '../../assets/symptoms/fullung.webp';
import iconFour from '../../assets/symptoms/pa.webp';
import iconFive from '../../assets/service/1_1.webp';
import iconSix from '../../assets/symptoms/prothese.webp';
import iconSeven from '../../assets/symptoms/schiene.webp';
import iconEight from '../../assets/symptoms/implantate.webp';
import iconNine from '../../assets/symptoms/prof.webp';
import iconTen from '../../assets/symptoms/kiefer.webp';

const Symptoms = () => {
    const { t } = useTranslation();

    const [showServices, setShowServices] = useState(false);

    const symptomsData = [
        {
            icon: iconOne,
            title: t('services.rootCanal.title'),
            description: t('services.rootCanal.description')
        },
        {
            icon: iconTwo,
            title: t('services.rootCanalRevision.title'),
            description: t('services.rootCanalRevision.description')
        },
        {
            icon: iconThree,
            title: t('services.fillings.title'),
            description: t('services.fillings.description')
        },
        {
            icon: iconFour,
            title: t('services.periodontitis.title'),
            description: t('services.periodontitis.description')
        },
        {
            icon: iconFive,
            title: t('services.dentalProsthetics.title'),
            description: t('services.dentalProsthetics.description')
        },
        {
            icon: iconSix,
            title: t('services.dentures.title'),
            description: t('services.dentures.description')
        },
        {
            icon: iconSeven,
            title: t('services.splints.title'),
            description: t('services.splints.description')
        },
        {
            icon: iconEight,
            title: t('services.implants.title'),
            description: t('services.implants.description')
        },
        {
            icon: iconNine,
            title: t('services.prophylaxis.title'),
            description: t('services.prophylaxis.description')
        },
        {
            icon: iconTen,
            title: t('services.orthodontics.title'),
            description: t('services.orthodontics.description')
        }
    ];

    return (
        <section
            className="symptoms-section section-common"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container">

                <SectionTitle
                    title={t('services.title')}
                    description={t('services.description')}
                />

                {/* Button */}
                <div className="services-toggle">
                    <button
                        type="button"
                        onClick={() => setShowServices(!showServices)}
                    >
                        {showServices
                            ? t('services.hide')
                            : t('services.show')}

                        <span
                            className={
                                showServices
                                    ? 'arrow open'
                                    : 'arrow'
                            }
                        >
                            ↓
                        </span>
                    </button>
                </div>

                {/* Leistungen */}
                <div
                    className={`services-wrapper ${
                        showServices ? 'show' : ''
                    }`}
                >
                    <div className="row">

                        {symptomsData.map((singleSymptoms) => (
                            <IconList
                                key={singleSymptoms.title}
                                icon={singleSymptoms.icon}
                                title={singleSymptoms.title}
                                description={singleSymptoms.description}
                            />
                        ))}

                    </div>

                    <div className="more-services">

                        <h2>
                            {t('services.moreTitle')}
                        </h2>

                        <p>
                            {t('services.moreDescription')}
                        </p>

                    </div>
                </div>

            </div>
        </section>
    );
};

export default Symptoms;